var _path, _circle, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusCreditCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "",
    height: "",
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.8576 6H3.14243C1.40972 6 0 7.41734 0 9.15941V21.1564C0 22.8985 1.40972 24.3158 3.14243 24.3158H20.8576C22.5903 24.3158 24 22.8985 24 21.1564V9.15941C24 7.41734 22.5903 6 20.8576 6ZM3.14268 7.9232H20.8578C21.5358 7.9232 22.0875 8.47788 22.0875 9.15949V11.953H1.91303V9.15949C1.91303 8.47788 2.46473 7.9232 3.14268 7.9232ZM3.14268 22.3927H20.8578C21.5358 22.3927 22.0875 21.838 22.0875 21.1564V16.4173H1.91303V21.1564C1.91303 21.838 2.46473 22.3927 3.14268 22.3927Z",
    fill: "#452359"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 6.5,
    r: 4.5,
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9583 3.70833H22.875V5.875H20.7083V6.95833H22.875V9.125H23.9583V6.95833H26.125V5.875H23.9583V3.70833ZM23.4167 1C20.4267 1 18 3.42667 18 6.41667C18 9.40667 20.4267 11.8333 23.4167 11.8333C26.4067 11.8333 28.8333 9.40667 28.8333 6.41667C28.8333 3.42667 26.4067 1 23.4167 1ZM23.4167 10.75C21.0279 10.75 19.0833 8.80542 19.0833 6.41667C19.0833 4.02792 21.0279 2.08333 23.4167 2.08333C25.8054 2.08333 27.75 4.02792 27.75 6.41667C27.75 8.80542 25.8054 10.75 23.4167 10.75Z",
    fill: "#452359"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusCreditCard);
export default __webpack_public_path__ + "static/media/plusCreditCard.e73651ae.svg";
export { ForwardRef as ReactComponent };